import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTextBubble(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 14.167a6.167 6.167 0 1 0-5.657-3.708c.105.24.132.51.055.76l-.517 1.675a1 1 0 0 0 1.234 1.255l1.77-.514c.24-.07.498-.044.729.053.734.308 1.54.479 2.386.479"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth={0.5}
        d="M4.417 7.833a.583.583 0 1 0 1.166 0 .583.583 0 0 0-1.166 0Zm3 0a.583.583 0 1 0 1.166 0 .583.583 0 0 0-1.166 0Zm3 0a.583.583 0 1 0 1.166 0 .583.583 0 0 0-1.166 0Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTextBubble);
export default ForwardRef;
